import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Login from 'components/pages/login'

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

const mapStateToProps = (state) => ({})

const render = connect(mapStateToProps, mapDispatchToProps)(Login)

export default render
